import { createFileRoute } from '@tanstack/react-router'
import { Settings } from 'lucide-react'

export const Route = createFileRoute('/_auth/_modules/_app/operations')({
  staticData: {
    title: 'route.operations',
    crumb: 'route.operations',
    icon: Settings,
    permissions: ['operations_execute'],
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
